// Get token from localStorage
export function getToken() {
  try {
    return typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
  } catch {
    return null;
  }
}

// Get user type from localStorage
export function getUserType() {
  try {
    return typeof window !== 'undefined' ? localStorage.getItem('userType') : null;
  } catch {
    return null;
  }
}

// Get user data from localStorage
export function getUser() {
  try {
    const user = typeof window !== 'undefined' ? localStorage.getItem('user') : null;
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
}

// Parse JWT token
export function parseJwt(token) {
  try {
    const base64 = token.split('.')[1];
    return JSON.parse(atob(base64.replace(/-/g, '+').replace(/_/g, '/'))) || {};
  } catch {
    return {};
  }
}

// Check if token is expired
export function isTokenExpired(token) {
  if (!token) return true;

  try {
    const { exp } = parseJwt(token);
    if (!exp) return false;
    return Math.floor(Date.now() / 1000) >= exp;
  } catch {
    return true;
  }
}

// Normalize role to lowercase
export function normalizeRole(role) {
  return String(role || '')
    .trim()
    .toLowerCase();
}

// Check if user is authenticated (client-side check)
export function isAuthenticated() {
  const token = getToken();
  return Boolean(token && !isTokenExpired(token));
}

export const handleTokenExpiration = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.clear();
  window.location.href = '/login';
};
